document.addEventListener('DOMContentLoaded', () => {
  const TRACKED = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'Placement', 'placement'];
  const incoming = new URLSearchParams(window.location.search);

  for (const root of document.querySelectorAll('[data-rfm-concerns]')) {
    for (const link of root.querySelectorAll('[data-rfm-product-link]')) {
      const url = new URL(link.href, window.location.origin);
      for (const key of TRACKED) {
        const value = incoming.get(key);
        if (value) url.searchParams.set(key, value);
      }
      link.href = url.toString();
    }

    const tabs = [...root.querySelectorAll('[data-rfm-tab]')];

    root.addEventListener('click', ({ target }) => {
      const tab = target.closest('[data-rfm-tab]');
      if (!tab) return;
      for (const other of tabs) {
        const isActive = other === tab;
        other.setAttribute('aria-pressed', String(isActive));
        root.querySelector(`#${other.getAttribute('aria-controls')}`).hidden = !isActive;
      }
    });
  }
});
